var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DCE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 8.89543 10.8954 8 12 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289L25.7071 13.2929C25.8946 13.4804 26 13.7348 26 14V26C26 27.1046 25.1046 28 24 28H12C10.8954 28 10 27.1046 10 26V10ZM23.5858 14L20 10.4142V14H23.5858ZM18 10L12 10V26H24V16H19C18.4477 16 18 15.5523 18 15V10ZM14 19C14 18.4477 14.4477 18 15 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H15C14.4477 20 14 19.5523 14 19ZM14 23C14 22.4477 14.4477 22 15 22H21C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24H15C14.4477 24 14 23.5523 14 23Z",
    fill: "#2C25C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderResume);
export default __webpack_public_path__ + "static/media/Header_Resume.1dae8a892a1ee166c51e19dbeeeea52a.svg";
export { ForwardRef as ReactComponent };